export default "__VITE_ASSET__eFYIsSmeyrhcwpIB9baEFA__";